var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("pdf-preview", {
        ref: "pdfPreview",
        attrs: { saving: _vm.saving, formData: _vm.formData },
        on: {
          "in-preview": function($event) {
            _vm.inPreview = $event
          },
          save: _vm.save,
          "save-preview": function($event) {
            return _vm.save(true)
          }
        }
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.inPreview,
              expression: "!inPreview"
            }
          ]
        },
        [
          _c(
            "form",
            {
              key: _vm.draftKey,
              attrs: { autocomplete: "off" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c("h2", [
                _vm._v(
                  "FORMULARIO INICIAL DE SOLICITUD DE ADQUISICIÓN DE BIENES O SERVICIOS"
                )
              ]),
              _c("div", { staticClass: "row mt-10" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c(
                      "b-form-group",
                      [
                        _c("label", { attrs: { for: "formType" } }, [
                          _vm._v(" ¿Deseas basarte en otro documento? ")
                        ]),
                        _c(
                          "v-select",
                          {
                            attrs: {
                              options: _vm.createdDocuments,
                              name: "previousDocument",
                              label: "label",
                              "data-cy": "created-document-data",
                              clearable: true
                            },
                            on: {
                              input: function($event) {
                                return _vm.getDocumentData($event)
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                _vm.hasMoreDocuments
                                  ? {
                                      key: "list-footer",
                                      fn: function() {
                                        return [
                                          _c(
                                            "li",
                                            {
                                              staticClass: "text-center py-2",
                                              staticStyle: {
                                                "border-top":
                                                  "1px solid #e8e8e8"
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticStyle: {
                                                    color: "#7367f0",
                                                    "font-weight": "500"
                                                  },
                                                  attrs: { href: "#" },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.loadMoreDocuments(
                                                        $event
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.loadingMoreDocuments
                                                          ? "Cargando..."
                                                          : "Cargar más documentos"
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  : null
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: _vm.previousDocument,
                              callback: function($$v) {
                                _vm.previousDocument = $$v
                              },
                              expression: "previousDocument"
                            }
                          },
                          [
                            _c("template", { slot: "no-options" }, [
                              _vm._v(" no hay documentos registrados ")
                            ])
                          ],
                          2
                        ),
                        _vm.$validator.errors.has("formType")
                          ? _c("v-invalid-feedback", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$validator.errors.first("formType")
                                  ) +
                                  " "
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._m(0),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("validate-field", {
                      attrs: {
                        field: "requesterUnit",
                        label: "Unidad requirente"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(ref) {
                            var invalid = ref.invalid
                            return [
                              _c("select-options", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  name: "requesterUnit",
                                  "alphabetical-sort": true,
                                  "options-group": "fisabs-requester-unit",
                                  "data-vv-as": "unidad requirente",
                                  "data-cy": "requester-unit",
                                  invalid: invalid
                                },
                                model: {
                                  value: _vm.formData.requesterUnit,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "requesterUnit", $$v)
                                  },
                                  expression: "formData.requesterUnit"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("validate-field", {
                      attrs: {
                        field: "requesterName",
                        label: "Responsable de elaborar la solicitud"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(ref) {
                            var invalid = ref.invalid
                            return [
                              _c("b-input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  name: "requesterName",
                                  placeholder:
                                    "Ingrese el nombre del responsable de elaborar la solicitud",
                                  "data-vv-as":
                                    "responsable de elaborar la solicitud",
                                  "data-cy": "requester-name",
                                  state: invalid
                                },
                                model: {
                                  value: _vm.formData.requesterName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "requesterName", $$v)
                                  },
                                  expression: "formData.requesterName"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("validate-field", {
                      attrs: {
                        field: "approverBossName",
                        label: "Nombre del jefe/a que aprueba la solicitud"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(ref) {
                            var invalid = ref.invalid
                            return [
                              _c("select-options", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  name: "approverBossName",
                                  "options-group": "fisabs-approver-boss-name",
                                  "alphabetical-sort": true,
                                  "data-vv-as":
                                    "nombre del jefe/a que aprueba la solicitud",
                                  "data-cy": "approver-boss-name",
                                  invalid: invalid
                                },
                                model: {
                                  value: _vm.formData.approverBossName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "approverBossName",
                                      $$v
                                    )
                                  },
                                  expression: "formData.approverBossName"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("validate-field", {
                      attrs: {
                        field: "approverBossPosition",
                        label: "Cargo del jefe/a que aprueba la solicitud"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(ref) {
                            var invalid = ref.invalid
                            return [
                              _c("select-options", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  name: "approverBossPosition",
                                  "options-group":
                                    "fisabs-approver-boss-position",
                                  "alphabetical-sort": true,
                                  "data-vv-as":
                                    "cargo del jefe/a que aprueba la solicitud",
                                  "data-cy": "approver-boss-position",
                                  invalid: invalid
                                },
                                model: {
                                  value: _vm.formData.approverBossPosition,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "approverBossPosition",
                                      $$v
                                    )
                                  },
                                  expression: "formData.approverBossPosition"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("validate-field", {
                      attrs: {
                        field: "contractMonitoringOfficer",
                        label: "Encargado de seguimiento contractual"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(ref) {
                            var invalid = ref.invalid
                            return [
                              _c("select-options", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  name: "contractMonitoringOfficer",
                                  "options-group":
                                    "fisabs-contract-monitoring-officer",
                                  "alphabetical-sort": true,
                                  "data-vv-as":
                                    "encargado de seguimiento contractual",
                                  "data-cy": "contract-monitoring-officer",
                                  invalid: invalid
                                },
                                model: {
                                  value: _vm.formData.contractMonitoringOfficer,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "contractMonitoringOfficer",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formData.contractMonitoringOfficer"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm._m(1),
                _c(
                  "div",
                  { staticClass: "col-12 mb-4" },
                  [
                    _c(
                      "validate-field",
                      { attrs: { field: "cdpNumber", label: "N° CDP" } },
                      [
                        _c("b-input", {
                          attrs: {
                            name: "cdpNumber",
                            placeholder: "Ingrese el número de CDP",
                            "data-cy": "cdp-number"
                          },
                          model: {
                            value: _vm.formData.cdpNumber,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "cdpNumber", $$v)
                            },
                            expression: "formData.cdpNumber"
                          }
                        })
                      ],
                      1
                    ),
                    _c("small", { staticClass: "italic" }, [
                      _vm._v(
                        "(Se debe adjuntar certificado de disponibilidad presupuestaria debidamente tramitado por la unidad de finanzas al final del formulario)"
                      )
                    ])
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("validate-field", {
                      attrs: {
                        field: "serviceCostCenter",
                        label: "Centro de Costo"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(ref) {
                            var invalid = ref.invalid
                            return [
                              _c("select-options", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  name: "serviceCostCenter",
                                  "options-group": "fisabs-service-cost-center",
                                  "data-vv-as": "centro de costo",
                                  "data-cy": "service-cost-center",
                                  invalid: invalid
                                },
                                model: {
                                  value: _vm.formData.serviceCostCenter,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "serviceCostCenter",
                                      $$v
                                    )
                                  },
                                  expression: "formData.serviceCostCenter"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("validate-field", {
                      attrs: {
                        field: "serviceFundingSource",
                        label: "Fuente de financiamiento"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(ref) {
                            var invalid = ref.invalid
                            return [
                              _c("select-options", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  name: "serviceFundingSource",
                                  "options-group":
                                    "fisabs-service-funding-source",
                                  "data-vv-as": "fuente de financiamiento",
                                  "data-cy": "service-funding-source",
                                  invalid: invalid
                                },
                                model: {
                                  value: _vm.formData.serviceFundingSource,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "serviceFundingSource",
                                      $$v
                                    )
                                  },
                                  expression: "formData.serviceFundingSource"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ]),
              _c("vs-divider"),
              _vm._m(2),
              _c("list-structure", {
                attrs: {
                  items: _vm.formData.items,
                  "default-item": _vm.initialItem,
                  "min-items": 1
                },
                on: { "add-item": _vm.onAddItem },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var id = ref.id
                      var item = ref.item
                      return [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12" }, [
                            _c("h4", [
                              _vm._v("Información del bien o servicio")
                            ])
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "budgetAccount-" + id,
                                  label: "Cuenta presupuestaria"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("select-options", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              placeholder:
                                                "Cuenta contable asignada a este tipo de gasto según ERP.",
                                              name: "budgetAccount-" + id,
                                              "options-group":
                                                "fisabs-budget-accounts",
                                              "data-vv-as":
                                                "cuenta presupuestaria",
                                              "data-cy": "budget-account",
                                              invalid: invalid
                                            },
                                            model: {
                                              value: item.budgetAccount,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "budgetAccount",
                                                  $$v
                                                )
                                              },
                                              expression: "item.budgetAccount"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "itemCatalogue-" + id,
                                  label:
                                    "Catálogo de bienes o servicios (ERP Global)"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("select-options-paginated", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              placeholder:
                                                "Debe hacer match con el código o nombre del ítem en ERP Global.",
                                              name: "itemCatalogue-" + id,
                                              "options-group":
                                                "fisabs-item-catalogue-erp",
                                              clearable: true,
                                              "data-vv-as":
                                                "catálogo de bienes o servicios (ERP Global)",
                                              "data-cy": "item-catalogue",
                                              invalid: invalid
                                            },
                                            model: {
                                              value: item.itemCatalogue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "itemCatalogue",
                                                  $$v
                                                )
                                              },
                                              expression: "item.itemCatalogue"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "requiredServiceName-" + id,
                                  label: "Nombre del bien o servicio requerido"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("b-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name: "requiredServiceName-" + id,
                                              placeholder:
                                                "Ingrese el nombre del bien o servicio requerido",
                                              "data-vv-as":
                                                "nombre del bien o servicio requerido",
                                              "data-cy":
                                                "required-service-name",
                                              state: invalid
                                            },
                                            model: {
                                              value: item.requiredServiceName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "requiredServiceName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.requiredServiceName"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "serviceStartDate-" + id,
                                  label: "Fecha de inicio del bien o servicio"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("date-picker", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name: "serviceStartDate-" + id,
                                              placeholder:
                                                "Seleccione la fecha de inicio del bien o servicio",
                                              "data-vv-as":
                                                "fecha de inicio del bien o servicio",
                                              "data-cy": "service-start-date",
                                              format: "DD-MM-YYYY",
                                              "value-type": "DD-MM-YYYY",
                                              invalid: invalid,
                                              disablePastDates: true
                                            },
                                            on: {
                                              "formatted-input": function(
                                                $event
                                              ) {
                                                item.serviceStartDate = $event
                                              }
                                            },
                                            model: {
                                              value: item.serviceStartDate,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "serviceStartDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.serviceStartDate"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          )
                        ]),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              class:
                                item.serviceDeliveryType ===
                                "Servicio en el tiempo"
                                  ? "col-md-6 col-12"
                                  : "col-12"
                            },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "serviceDeliveryType-" + id,
                                  label: "Tipo de entrega del bien o servicio"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("select-options", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name: "serviceDeliveryType-" + id,
                                              "data-vv-as":
                                                "tipo de entrega del bien o servicio",
                                              "data-cy":
                                                "service-delivery-type",
                                              invalid: invalid,
                                              mapper: function(opt) {
                                                return {
                                                  value: opt,
                                                  label: opt
                                                }
                                              },
                                              options:
                                                _vm.options.serviceDeliveryType
                                            },
                                            on: {
                                              input: function($event) {
                                                item.serviceDeliveryFrequency =
                                                  ""
                                              }
                                            },
                                            model: {
                                              value: item.serviceDeliveryType,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "serviceDeliveryType",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.serviceDeliveryType"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          item.serviceDeliveryType === "Servicio en el tiempo"
                            ? _c(
                                "div",
                                { staticClass: "col-md-6 col-12" },
                                [
                                  _c("validate-field", {
                                    attrs: {
                                      field: "serviceDeliveryFrequency-" + id,
                                      label: "Frecuencia de entrega"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c("select-options", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  }
                                                ],
                                                attrs: {
                                                  name:
                                                    "serviceDeliveryFrequency-" +
                                                    id,
                                                  "options-group":
                                                    "fisabs-service-delivery-frequency",
                                                  "alphabetical-sort": true,
                                                  "data-vv-as":
                                                    "frecuencia de entrega",
                                                  "data-cy":
                                                    "service-delivery-frequency",
                                                  invalid: invalid
                                                },
                                                model: {
                                                  value:
                                                    item.serviceDeliveryFrequency,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "serviceDeliveryFrequency",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.serviceDeliveryFrequency"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          item.serviceDeliveryType === "Servicio en el tiempo"
                            ? _c(
                                "div",
                                { staticClass: "col-12" },
                                [
                                  _c("validate-field", {
                                    attrs: {
                                      field: "serviceDeliveryPeriodicity-" + id,
                                      label: "Periodicidad de entrega"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c("date-picker", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  }
                                                ],
                                                attrs: {
                                                  name:
                                                    "serviceDeliveryPeriodicity-" +
                                                    id,
                                                  placeholder:
                                                    "Seleccione la periodicidad de entrega",
                                                  "data-vv-as":
                                                    "periodicidad de entrega",
                                                  "data-cy":
                                                    "service-delivery-periodicity",
                                                  invalid: invalid,
                                                  multiple: "",
                                                  disablePastDates: true
                                                },
                                                on: {
                                                  "formatted-input": function(
                                                    $event
                                                  ) {
                                                    item.serviceDeliveryPeriodicity = $event
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    item.serviceDeliveryPeriodicity,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "serviceDeliveryPeriodicity",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.serviceDeliveryPeriodicity"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ]),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              class:
                                item.serviceDeliveryLocation ===
                                _vm.OTHER_ADDRESS
                                  ? "col-md-6 col-12"
                                  : "col-12"
                            },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "serviceDeliveryLocation-" + id,
                                  label:
                                    "Dirección de despacho del bien o servicio"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("select-options", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name:
                                                "serviceDeliveryLocation-" + id,
                                              "data-vv-as":
                                                "dirección de despacho del bien o servicio",
                                              "data-cy":
                                                "service-delivery-location",
                                              invalid: invalid,
                                              "options-group":
                                                "fisabs-service-delivery-location"
                                            },
                                            on: {
                                              input: function(value) {
                                                return _vm.handleLocationChange(
                                                  value,
                                                  item
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                item.serviceDeliveryLocation,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "serviceDeliveryLocation",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.serviceDeliveryLocation"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          item.serviceDeliveryLocation === _vm.OTHER_ADDRESS
                            ? _c(
                                "div",
                                { staticClass: "col-md-6 col-12" },
                                [
                                  _c("validate-field", {
                                    attrs: {
                                      field:
                                        "serviceDeliveryLocationCustom-" + id,
                                      label:
                                        "Dirección y oficina a la que corresponde"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c("b-input", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  }
                                                ],
                                                attrs: {
                                                  name:
                                                    "serviceDeliveryLocationCustom-" +
                                                    id,
                                                  placeholder:
                                                    "Ingrese la dirección y oficina a la que corresponde",
                                                  "data-vv-as":
                                                    "dirección y oficina a la que corresponde",
                                                  "data-cy":
                                                    "service-delivery-location-custom",
                                                  state: invalid
                                                },
                                                model: {
                                                  value:
                                                    item.serviceDeliveryLocationCustom,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "serviceDeliveryLocationCustom",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.serviceDeliveryLocationCustom"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          item.serviceDeliveryLocation &&
                          item.serviceDeliveryLocation !== _vm.DEFAULT_ADDRESS
                            ? _c(
                                "div",
                                { staticClass: "col-12" },
                                [
                                  _c("validate-field", {
                                    attrs: {
                                      field:
                                        "serviceDeliveryLocationCustom-" + id,
                                      label: "Justificación"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c("b-input", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  }
                                                ],
                                                attrs: {
                                                  name:
                                                    "serviceDeliveryLocationJustification-" +
                                                    id,
                                                  placeholder:
                                                    "Ingrese la justificación de otra dirección",
                                                  "data-vv-as": "justificación",
                                                  "data-cy":
                                                    "service-delivery-location-justification",
                                                  state: invalid
                                                },
                                                model: {
                                                  value:
                                                    item.serviceDeliveryLocationJustification,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "serviceDeliveryLocationJustification",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.serviceDeliveryLocationJustification"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ]),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [_c("vs-divider")],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12 mb-2 " },
                            [
                              _c("link-button", {
                                staticClass: "mb-2",
                                attrs: {
                                  title: "Catálogo ERP Global",
                                  link: item.linkCatalogoErpGlobal
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("link-button", {
                                staticClass: "mb-2",
                                attrs: {
                                  title: "Ir a catálogo de convenio marco",
                                  link:
                                    "https://www.mercadopublico.cl/TiendaHome/"
                                }
                              }),
                              _c("validate-field", {
                                attrs: {
                                  field: "catalogAvailability-" + id,
                                  label:
                                    "Disponibilidad en catálogo de convenio marco."
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("select-options", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name: "catalogAvailability-" + id,
                                              "data-vv-as":
                                                "disponibilidad en catálogo de convenio marco",
                                              "data-cy": "catalog-availability",
                                              invalid: invalid,
                                              options: _vm.options.yesOrNo,
                                              mapper: function(opt) {
                                                return {
                                                  value: opt,
                                                  label: opt
                                                }
                                              }
                                            },
                                            model: {
                                              value: item.catalogAvailability,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "catalogAvailability",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.catalogAvailability"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [_c("vs-divider", { staticClass: "mt-0" })],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "criteriaToSelectProvider-" + id,
                                  label:
                                    "Criterios que se deben considerar para seleccionar proveedor"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("select-options", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name:
                                                "criteriaToSelectProvider-" +
                                                id,
                                              "data-vv-as":
                                                "criterios que se deben considerar para seleccionar proveedor",
                                              "data-cy":
                                                "criteria-to-select-provider",
                                              invalid: invalid,
                                              options:
                                                _vm.options
                                                  .criteriaToSelectProvider,
                                              mapper: function(opt) {
                                                return {
                                                  value: opt,
                                                  label: opt
                                                }
                                              },
                                              multiple: ""
                                            },
                                            on: {
                                              input: function($event) {
                                                item.providerSelectionCriteria =
                                                  ""
                                              }
                                            },
                                            model: {
                                              value:
                                                item.criteriaToSelectProvider,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "criteriaToSelectProvider",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.criteriaToSelectProvider"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          item.criteriaToSelectProvider &&
                          item.criteriaToSelectProvider
                            .join()
                            .includes("Otro (detallar)")
                            ? _c(
                                "div",
                                { staticClass: "col-12" },
                                [
                                  _c("validate-field", {
                                    attrs: {
                                      field: "providerSelectionCriteria-" + id,
                                      label:
                                        "Detalle del criterio de selección de proveedor"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c("b-input", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  }
                                                ],
                                                attrs: {
                                                  name:
                                                    "providerSelectionCriteria-" +
                                                    id,
                                                  placeholder:
                                                    "Ingrese el detalle del criterio de selección de proveedor",
                                                  "data-vv-as":
                                                    "detalle del criterio de selección de proveedor",
                                                  "data-cy":
                                                    "provider-selection-criteria",
                                                  state: invalid
                                                },
                                                model: {
                                                  value:
                                                    item.providerSelectionCriteria,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "providerSelectionCriteria",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.providerSelectionCriteria"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c("div", { staticClass: "col-12" }, [
                            _c("h4", [
                              _vm._v("Detalle técnico y valor estimado")
                            ])
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "serviceQuantity-" + id,
                                  label: "Cantidad"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("b-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              type: "number",
                                              name: "serviceQuantity-" + id,
                                              placeholder:
                                                "Ingrese la cantidad",
                                              "data-vv-as": "cantidad",
                                              "data-cy": "service-quantity",
                                              state: invalid
                                            },
                                            on: {
                                              input: function($event) {
                                                return _vm.calculateSubtotal(
                                                  item
                                                )
                                              }
                                            },
                                            model: {
                                              value: item.serviceQuantity,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "serviceQuantity",
                                                  $$v
                                                )
                                              },
                                              expression: "item.serviceQuantity"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "serviceMeasure-" + id,
                                  label: "Medida"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("select-options", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name: "serviceMeasure-" + id,
                                              "options-group":
                                                "fisabs-service-measure",
                                              "alphabetical-sort": true,
                                              "data-vv-as": "medida",
                                              "data-cy": "service-measure",
                                              invalid: invalid
                                            },
                                            model: {
                                              value: item.serviceMeasure,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "serviceMeasure",
                                                  $$v
                                                )
                                              },
                                              expression: "item.serviceMeasure"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "serviceSpecifications-" + id,
                                  label:
                                    "Especificaciones técnicas del bien o servicio"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("b-form-textarea", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name:
                                                "serviceSpecifications-" + id,
                                              "data-vv-as":
                                                "especificaciones técnicas del bien o servicio",
                                              "data-cy":
                                                "service-specifications",
                                              state: invalid,
                                              maxlength: 2000,
                                              placeholder:
                                                "Ingrese las especificaciones técnicas del bien o servicio",
                                              rows: "3",
                                              "max-rows": "8"
                                            },
                                            model: {
                                              value: item.serviceSpecifications,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "serviceSpecifications",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.serviceSpecifications"
                                            }
                                          }),
                                          _c(
                                            "small",
                                            {
                                              staticClass:
                                                "form-text text-muted text-right"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    item.serviceSpecifications
                                                      ? item
                                                          .serviceSpecifications
                                                          .length
                                                      : 0
                                                  ) +
                                                  " / 2000 "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "serviceAmount-" + id,
                                  label: "Monto (CLP)"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("number-currency-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value:
                                                  "required|minCurrencyValue:1",
                                                expression:
                                                  "'required|minCurrencyValue:1'"
                                              }
                                            ],
                                            attrs: {
                                              name: "serviceAmount-" + id,
                                              "data-vv-as": "monto",
                                              "data-cy": "service-amount",
                                              state: invalid
                                            },
                                            on: {
                                              input: function($event) {
                                                return _vm.calculateSubtotal(
                                                  item
                                                )
                                              }
                                            },
                                            model: {
                                              value: item.serviceAmount,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "serviceAmount",
                                                  $$v
                                                )
                                              },
                                              expression: "item.serviceAmount"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "subtotalAmount-" + id,
                                  label: "Subtotal (CLP)"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c(
                                            "b-input-group",
                                            { attrs: { prepend: "$" } },
                                            [
                                              _c("b-input", {
                                                attrs: {
                                                  name: "subtotalAmount-" + id,
                                                  "data-vv-as": "subtotal",
                                                  "data-cy": "subtotal-amount",
                                                  state: invalid,
                                                  readonly: ""
                                                },
                                                model: {
                                                  value: item.subtotalAmount,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "subtotalAmount",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.subtotalAmount"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c(
                                "validate-field",
                                {
                                  attrs: {
                                    field: "serviceGlosa-" + id,
                                    label:
                                      "Glosa (nombre del proyecto cuando corresponda)"
                                  }
                                },
                                [
                                  _c("b-input", {
                                    attrs: {
                                      name: "serviceGlosa-" + id,
                                      placeholder: "Ingrese la glosa",
                                      "data-cy": "service-glosa"
                                    },
                                    model: {
                                      value: item.serviceGlosa,
                                      callback: function($$v) {
                                        _vm.$set(item, "serviceGlosa", $$v)
                                      },
                                      expression: "item.serviceGlosa"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c(
                                "validate-field",
                                {
                                  attrs: {
                                    field: "serviceAgreementCode-" + id,
                                    label:
                                      "Código de convenio marco (solo si aplica)"
                                  }
                                },
                                [
                                  _c("b-input", {
                                    attrs: {
                                      name: "serviceAgreementCode-" + id,
                                      placeholder:
                                        "Ingrese el código de convenio marco",
                                      "data-cy": "service-agreement-code"
                                    },
                                    model: {
                                      value: item.serviceAgreementCode,
                                      callback: function($$v) {
                                        _vm.$set(
                                          item,
                                          "serviceAgreementCode",
                                          $$v
                                        )
                                      },
                                      expression: "item.serviceAgreementCode"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "observations-" + id,
                                  label: "Observaciones del ítem"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("b-form-textarea", {
                                            attrs: {
                                              name: "observations-" + id,
                                              "data-vv-as":
                                                "observaciones del ítem",
                                              "data-cy": "service-observations",
                                              state: invalid,
                                              maxlength: 2000,
                                              placeholder:
                                                "Ingrese observaciones complementarias del ítem",
                                              rows: "3",
                                              "max-rows": "8"
                                            },
                                            model: {
                                              value: item.observations,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "observations",
                                                  $$v
                                                )
                                              },
                                              expression: "item.observations"
                                            }
                                          }),
                                          _c(
                                            "small",
                                            {
                                              staticClass:
                                                "form-text text-muted text-right"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    item.observations
                                                      ? item.observations.length
                                                      : 0
                                                  ) +
                                                  " / 2000 "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _c("div", { staticClass: "col-12" }, [
                            _c("h4", [
                              _vm._v("Información relacionada a proyectos ")
                            ])
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "serviceInPurchasePlan-" + id,
                                  label:
                                    "¿Está en Plan de Gastos? (Solo para Proyectos)"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("select-options", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name:
                                                "serviceInPurchasePlan-" + id,
                                              "data-vv-as":
                                                "indicar si está en plan de gastos",
                                              "data-cy":
                                                "service-in-purchase-plan",
                                              invalid: invalid,
                                              options: _vm.options.yesOrNo,
                                              mapper: function(opt) {
                                                return {
                                                  value: opt,
                                                  label: opt
                                                }
                                              }
                                            },
                                            model: {
                                              value: item.serviceInPurchasePlan,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "serviceInPurchasePlan",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.serviceInPurchasePlan"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          item.serviceInPurchasePlan === "No"
                            ? _c(
                                "div",
                                { staticClass: "col-12" },
                                [
                                  _c("validate-field", {
                                    attrs: {
                                      field:
                                        "servicePurchasePlanJustification-" +
                                        id,
                                      label:
                                        "Justificación en caso de no estar en plan de gastos"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c("b-input", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  }
                                                ],
                                                attrs: {
                                                  name:
                                                    "servicePurchasePlanJustification-" +
                                                    id,
                                                  placeholder:
                                                    "Ingrese la justificación",
                                                  "data-vv-as":
                                                    "justificación en caso de no estar en plan de gastos",
                                                  "data-cy":
                                                    "service-purchase-plan-justification",
                                                  state: invalid
                                                },
                                                model: {
                                                  value:
                                                    item.servicePurchasePlanJustification,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "servicePurchasePlanJustification",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.servicePurchasePlanJustification"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c(
                                "validate-field",
                                {
                                  attrs: {
                                    field: "serviceExpenseClassification-" + id,
                                    label:
                                      "Clasificación del gasto (solo para proyecto)"
                                  }
                                },
                                [
                                  _c("select-options", {
                                    attrs: {
                                      name:
                                        "serviceExpenseClassification-" + id,
                                      "options-group":
                                        "fisabs-service-expense-classification",
                                      "data-cy":
                                        "service-expense-classification",
                                      "alphabetical-sort": true,
                                      "filter-by-doc-type": _vm.DOC_TYPE
                                    },
                                    model: {
                                      value: item.serviceExpenseClassification,
                                      callback: function($$v) {
                                        _vm.$set(
                                          item,
                                          "serviceExpenseClassification",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "item.serviceExpenseClassification"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c(
                                "validate-field",
                                {
                                  attrs: {
                                    field: "serviceProjectObjective-" + id,
                                    label: "Objetivo del proyecto"
                                  }
                                },
                                [
                                  _c("b-input", {
                                    attrs: {
                                      name: "serviceProjectObjective-" + id,
                                      placeholder:
                                        "Ingrese el objetivo del proyecto",
                                      "data-cy": "service-project-objective"
                                    },
                                    model: {
                                      value: item.serviceProjectObjective,
                                      callback: function($$v) {
                                        _vm.$set(
                                          item,
                                          "serviceProjectObjective",
                                          $$v
                                        )
                                      },
                                      expression: "item.serviceProjectObjective"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c(
                                "validate-field",
                                {
                                  attrs: {
                                    field: "serviceResult-" + id,
                                    label:
                                      "Resultado / Hito / Actividad principal / Indicador"
                                  }
                                },
                                [
                                  _c("b-input", {
                                    attrs: {
                                      name: "serviceResult-" + id,
                                      placeholder:
                                        "Ingrese el resultado/hito/actividad principal/indicador",
                                      "data-cy": "service-result"
                                    },
                                    model: {
                                      value: item.serviceResult,
                                      callback: function($$v) {
                                        _vm.$set(item, "serviceResult", $$v)
                                      },
                                      expression: "item.serviceResult"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c(
                                "validate-field",
                                {
                                  attrs: {
                                    field: "serviceExpenseCode-" + id,
                                    label:
                                      "Código del gasto en el plan de gastos del proyecto"
                                  }
                                },
                                [
                                  _c("b-input", {
                                    attrs: {
                                      name: "serviceExpenseCode-" + id,
                                      placeholder:
                                        "Ingrese el código del gasto en el plan de gastos del proyecto",
                                      "data-cy": "service-expense-code"
                                    },
                                    model: {
                                      value: item.serviceExpenseCode,
                                      callback: function($$v) {
                                        _vm.$set(
                                          item,
                                          "serviceExpenseCode",
                                          $$v
                                        )
                                      },
                                      expression: "item.serviceExpenseCode"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c("vs-divider"),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c(
                  "b-form-group",
                  { staticClass: "mt-0 mt-md-8" },
                  [
                    _c(
                      "b-form-checkbox",
                      {
                        staticClass: "m-0",
                        attrs: {
                          name: "initiatedFisabs",
                          "data-cy": "initiated-fisabs",
                          "data-vv-as":
                            "¿Esta solicitud complementa un requerimiento ya iniciado?"
                        },
                        on: {
                          change: function() {
                            _vm.formData.createdFisabsSelected = {}
                            _vm.formData.fisabsSelected = ""
                          }
                        },
                        model: {
                          value: _vm.formData.initiatedFisabs,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "initiatedFisabs", $$v)
                          },
                          expression: "formData.initiatedFisabs"
                        }
                      },
                      [
                        _vm._v(
                          " ¿Esta solicitud complementa un requerimiento ya iniciado? "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm.formData.initiatedFisabs
              ? _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("validate-field", {
                      attrs: {
                        field: "createdFisabsSelected",
                        label: "FISABS anterior asociado"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var invalid = ref.invalid
                              return [
                                _c(
                                  "v-select",
                                  {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required: _vm.formData.initiatedFisabs
                                        },
                                        expression:
                                          "{required: formData.initiatedFisabs}"
                                      }
                                    ],
                                    class: {
                                      "v-select-danger": invalid === false
                                    },
                                    attrs: {
                                      options: _vm.createdFisabs,
                                      name: "createdFisabsSelected",
                                      label: "label",
                                      "data-vv-as": "FISABS anterior asociado",
                                      "data-cy": "created-fisabs-selected",
                                      reduce: function(option) {
                                        return option.id
                                      },
                                      clearable: true
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.formData.createdFisabsSelected = _vm.createdFisabs.find(
                                          function(elem) {
                                            return elem.id === $event
                                          }
                                        )
                                      }
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        _vm.hasMoreFisabs
                                          ? {
                                              key: "list-footer",
                                              fn: function() {
                                                return [
                                                  _c(
                                                    "li",
                                                    {
                                                      staticClass:
                                                        "text-center py-2",
                                                      staticStyle: {
                                                        "border-top":
                                                          "1px solid #e8e8e8"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticStyle: {
                                                            color: "#7367f0",
                                                            "font-weight": "500"
                                                          },
                                                          attrs: { href: "#" },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              return _vm.loadMoreFisabs(
                                                                $event
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.loadingMoreFisabs
                                                                  ? "Cargando..."
                                                                  : "Cargar más FISABS"
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              },
                                              proxy: true
                                            }
                                          : null
                                      ],
                                      null,
                                      true
                                    ),
                                    model: {
                                      value: _vm.formData.fisabsSelected,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "fisabsSelected",
                                          $$v
                                        )
                                      },
                                      expression: "formData.fisabsSelected"
                                    }
                                  },
                                  [
                                    _c("template", { slot: "no-options" }, [
                                      _vm._v(" no hay FISABS registrados ")
                                    ])
                                  ],
                                  2
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        289973283
                      )
                    }),
                    _c("label")
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("validate-field", {
                  attrs: {
                    field: "general-observations",
                    label: "Observaciones generales de la solicitud"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        var invalid = ref.invalid
                        return [
                          _c("b-form-textarea", {
                            attrs: {
                              name: "general-observations",
                              "data-vv-as":
                                "observaciones generales de la solicitud",
                              "data-cy": "general-observations",
                              state: invalid,
                              maxlength: 2000,
                              placeholder: "Observaciones generales",
                              rows: "3",
                              "max-rows": "8"
                            },
                            model: {
                              value: _vm.formData.generalObservations,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "generalObservations",
                                  $$v
                                )
                              },
                              expression: "formData.generalObservations"
                            }
                          }),
                          _c(
                            "small",
                            { staticClass: "form-text text-muted text-right" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formData.generalObservations
                                      ? _vm.formData.generalObservations.length
                                      : 0
                                  ) +
                                  " / 2000 "
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _vm.dfsSelectorsLoading || _vm.dfsSelectors.length
                  ? _c("div", { staticClass: "h2" }, [_vm._v("Adjuntos")])
                  : _vm._e(),
                !_vm.dfsSelectorsLoading
                  ? _c("dynamic-file-selector", {
                      attrs: {
                        selectors: _vm.dfsSelectors,
                        "object-to-evaluate": _vm.formData,
                        files: _vm.dfsFiles,
                        "reset-key": _vm.dfsResetKey
                      },
                      on: {
                        "update-files": _vm.dfsUpdateFiles,
                        valid: function(valid) {
                          return (_vm.dfsValid = valid)
                        }
                      }
                    })
                  : _c(
                      "div",
                      [
                        _c("b-skeleton", {
                          attrs: { animation: "fade", width: "100%" }
                        }),
                        _c("b-skeleton", {
                          attrs: { animation: "fade", width: "100%" }
                        })
                      ],
                      1
                    )
              ],
              1
            )
          ]),
          _vm._m(3),
          _c("form-buttons", {
            attrs: {
              saving: _vm.saving,
              disabled: _vm.dfsSelectorsLoading,
              back: function() {
                return this$1.$router.back()
              },
              preview: _vm.preview,
              save: function() {
                return _vm.save(false)
              },
              saveDraft: _vm.saveDraft
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h4", [_vm._v("IDENTIFICACIÓN DEL REQUIRENTE")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 mt-5" }, [
      _c("h4", [_vm._v(" ANTECEDENTES PRESUPUESTARIOS GENERALES ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row my-5" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h4", [_vm._v("SERVICIOS O BIENES REQUERIDOS")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-xs text-right" }, [
      _c("b", [
        _vm._v("Los campos marcados con "),
        _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
        _vm._v(" son obligatorios")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }